import Vue from 'vue'
import Router from 'vue-router'
import HomeApp from '@/modules/Home/HomeApp'
import SalaAulaApp from '@/modules/SalaAula/SalaAulaApp'
import PerfilApp from '@/modules/Perfil/PerfilApp'
import MeusDadosPerfil from '@/modules/Perfil/components/MeusDadosPerfil'
import MeusTutoresPerfil from '@/modules/Perfil/components/MeusTutoresPerfil'
import MeusCadernosPerfil from '@/modules/Perfil/components/MeusCadernosPerfil'
import CursosApp from '@/modules/Cursos/CursosApp'
import EmentaCursoApp from '@/modules/Cursos/EmentaCursoApp'
import LoginView from '@/modules/Login/LoginView'
import LoginPorTokenView from '@/modules/Login/LoginPorTokenView'
import LoginUtils from '@/core/utils/login-utils'
import PaginaNaoEncontradaView from '@/components/PaginaNaoEncontradaView'
import ErrorView from '@/components/ErrorView'
import ListaSimuladosView from '@/modules/Simulados/ListaSimuladosView'
import NovoSimuladoView from '@/modules/Simulados/NovoSimuladoView'
import RecuperarSenhaView from '@/modules/Login/RecuperarSenhaView'
import SimuladoProvaView from '@/modules/Simulados/SimuladoProvaView'
import SimuladoView from '@/modules/Simulados/SimuladoView'
import SimuladoResultadoView from '@/modules/Simulados/SimuladoResultadoView'
import ResultadoBuscaView from '@/modules/Busca/ResultadoBuscaView'
import ContatoView from '@/modules/Contato/ContatoView'
import SimuladoModoView from '@/modules/Simulados/components/SimuladoModoView'
import TopicoSalaAulaInterno from '@/modules/SalaAula/components/topicos/TopicoSalaAulaInterno'
import RedefinicaoSenhaView from '@/modules/Login/RedefinicaoSenhaView'
import SistemaView from '@/modules/Cursos/SistemaView'
import DisciplinaView from '@/modules/Cursos/DisciplinaView'
import AjudaView from '@/modules/Ajuda/AjudaView'
import Faq from '@/modules/Ajuda/components/Faq'
import LivesView from '@/modules/Lives/LivesView'
import Artmed360View from '@/modules/Artmed360/Artmed360View'
import NotificacoesView from '@/modules/Notificacoes/NotificacoesView'
import FerramentasView from '@/modules/Ferramentas/FerramentasView'

Vue.use(Router)

const verificarAutenticacao = (to, from, next) => {
  const isUsuarioLogado = LoginUtils.isUsuarioLogado()
  if (isUsuarioLogado) {
    next()
  } else {
    next({ name: 'login', query: { redir: to.path } })
  }
  return isUsuarioLogado
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/home',
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      beforeEnter: (to, from, next) => LoginUtils.isUsuarioLogado() ? next({ name: 'home' }) : next()
    },
    {
      path: '/login/recuperar-senha',
      name: 'recuperar-senha',
      component: RecuperarSenhaView
    },
    {
      path: '/password/reset',
      name: 'redefinir-senha-sem-token',
      redirect: '/login/recuperar-senha'
    },
    {
      path: '/password/reset/:token',
      name: 'redefinir-senha',
      component: RedefinicaoSenhaView
    },
    {
      path: '/password/primeiro-acesso/:token',
      name: 'primeiro-acesso-redefinir-senha',
      component: RedefinicaoSenhaView
    },
    {
      path: '/login/token/:token',
      name: 'login-por-token',
      component: LoginPorTokenView
    },
    {
      path: '/home',
      name: 'HomeApp',
      component: HomeApp,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/categoria/:referencia',
      name: 'categoria',
      component: CursosApp,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/disciplina/:referencia',
      name: 'disciplina',
      component: DisciplinaView,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/sistema/:referencia',
      name: 'sistema',
      component: SistemaView,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/cursos',
      name: 'Cursos',
      component: CursosApp,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/cursos/categoria/:id',
      name: 'curso-id-categoria',
      component: CursosApp,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/cursos/disciplina/:id',
      name: 'curso-id-disciplina',
      component: CursosApp,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/cursos/sistema/:id',
      name: 'curso-id-sistema',
      component: CursosApp,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/cursos/detalhe/:referenciaCurso',
      name: 'DetalheCurso',
      component: EmentaCursoApp,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/cursos/detalhe/curso/:idCurso',
      name: 'DetalheCursoPorId',
      component: EmentaCursoApp,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/sala-de-aula/:referenciaCurso',
      name: 'sala-de-aula',
      component: SalaAulaApp,
      beforeEnter: verificarAutenticacao,
      children: [
        { name: 'sala-de-aula-topico-sala-aula', path: ':modulo?/:licao?/:topico?', component: TopicoSalaAulaInterno }
      ]
    },
    {
      path: '/perfil',
      name: 'Perfil',
      component: PerfilApp,
      beforeEnter: verificarAutenticacao,
      redirect: { name: 'meus-dados' },
      children: [
        { name: 'meus-dados', path: 'meus-dados', component: MeusDadosPerfil },
        { name: 'meus-tutores', path: 'meus-tutores', component: MeusTutoresPerfil },
        { name: 'cadernos', path: 'cadernos', component: MeusCadernosPerfil }
      ]
    },
    {
      path: '/simulados',
      name: 'Simulados',
      component: SimuladoView,
      beforeEnter: verificarAutenticacao,
      redirect: { name: 'simulado-listar' },
      children: [
        { name: 'simulado-novo', path: 'novo', component: NovoSimuladoView },
        { name: 'simulado-listar', path: 'listar', component: ListaSimuladosView },
        { name: 'simulado-prova', path: 'prova/:simulado', component: SimuladoProvaView },
        { name: 'simulado-prova-questao', path: 'prova/:simulado/questao/:ordem', component: SimuladoProvaView },
        { name: 'simulado-revisao-prova-erros', path: 'prova/:simulado/questao/:ordem/revisao/erros', component: SimuladoProvaView },
        { name: 'simulado-revisao-prova-acertos', path: 'prova/:simulado/questao/:ordem/revisao/acertos', component: SimuladoProvaView },
        { name: 'simulado-revisao-prova-nao-respondidas', path: 'prova/:simulado/questao/:ordem/revisao/nao-respondidas', component: SimuladoProvaView },
        { name: 'simulado-revisao-prova-todas', path: 'prova/:simulado/questao/:ordem/revisao/todas', component: SimuladoProvaView },
        { name: 'simulado-resultado', path: 'resultado/:simulado', component: SimuladoResultadoView },
        { name: 'simulado-iniciar', path: ':simulado/modo', component: SimuladoModoView }
      ]
    },
    {
      path: '/busca',
      name: 'Busca',
      component: ResultadoBuscaView,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/contato',
      name: 'contato',
      component: ContatoView,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/ajuda',
      name: 'ajuda',
      component: AjudaView,
      beforeEnter: verificarAutenticacao,
      redirect: { name: 'faq' },
      children: [
        { name: 'faq', path: 'faq', component: Faq }
      ]
    },
    {
      path: '/lives',
      name: 'lives',
      component: LivesView,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/artmed360',
      name: 'artmed360',
      component: Artmed360View,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/notificacoes',
      name: 'notificacoes',
      component: NotificacoesView,
      beforeEnter: verificarAutenticacao
    },
    {
      path: '/error',
      name: 'errors',
      component: ErrorView,
      beforeEnter: verificarAutenticacao
    },
    {
      name: 'not-found',
      path: '/not-found',
      alias: '*',
      component: PaginaNaoEncontradaView
    },
    {
      path: '/ferramentas',
      name: 'ferramentas',
      component: FerramentasView,
      props: true,
      beforeEnter: verificarAutenticacao
    }
  ]
})
